import { render, staticRenderFns } from "./HeaderCampus.vue?vue&type=template&id=40563aa8"
import script from "./HeaderCampus.vue?vue&type=script&lang=js"
export * from "./HeaderCampus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports